import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PersonaService } from 'src/app/services/persona.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'apc-import-persona',
  templateUrl: './import-persona.component.html',
  styleUrls: ['./import-persona.component.scss']
})
export class ImportPersonaComponent {
  public form: UntypedFormGroup;
  public isSaved: boolean = false;
  public existingPersonaModalRef: any;
  public numberOfExistingModals: number = 0;
  quickSearch = new Subject<any>();
  queryString: string = '';
  searchValue: string = '';
  result: any = [];
  isLoading: boolean = false;
  personaSelected: boolean = false;
  personaAlreadyImported = null;
  personaAlreadyImportedDate;
  personaAlreadyImportedStatus: any;

  constructor(
    private modalService: NgbModal, 
    private personaService: PersonaService, 
    private router: Router, 
    private toastService: ToastService
  ) {
    this.quickSearch.pipe(debounceTime(1000), distinctUntilChanged()).subscribe((input) => {
      this.search(input.value);
    });
    this.initSingleForm();
  }

  initSingleForm() {
    this.form = new UntypedFormGroup({
      persona: new UntypedFormControl(null, [Validators.required])
    });
  }

  close() {
    this.initSingleForm();
    this.modalService.dismissAll();
  }

  async search(value: string) {
    this.searchValue = value;
    this.queryString = this.searchValue;
    this.isLoading = true;
    this.result = [];
    if (this.queryString.length > 0) {
      this.personaService.getPersonasForImport(this.queryString).then(
        (res) => {
          this.result = res;
          this.isLoading = false;
          console.log("RESULT->>", res);
        },
        (reason) => {
          this.isLoading = false;
        }
      );
    } else {
      this.result = [];
      this.isLoading = false;
    }
  }

  closeSearch() {
    this.result = [];
    this.searchValue = '';
    this.queryString = '';
    this.isLoading = false;
    this.personaSelected = false;
    this.form.reset();
  }

  selectPersona(persona) {
    this.personaSelected = true;
    this.form.controls.persona.patchValue(persona);
    this.searchValue = this.constructDisplayName(persona);
  }

  constructDisplayName(persona) {
    return persona.name + ' ' + persona.surname + ' (' + persona.uid + ')';
  }

  save() {
    this.personaService.importPersona(this.form.value.persona.uid).then((res: any) => {
      this.close();
      this.toastService.showSuccess('Persona imported successfully!');
      this.router.navigateByUrl('/persona/' + res.identifier + '/profile/company');
    },
      (err) => {
        if (err.identifier) {
          this.personaAlreadyImported = err.identifier;
          this.personaAlreadyImportedDate = err.date;
          this.personaAlreadyImportedStatus = err.status
        }
      })
  }

  goToPersona() {
    this.close();
    this.router.navigateByUrl('/persona/' + this.personaAlreadyImported + '/profile/company');
  }

  backToImport() {
    this.personaAlreadyImported = null;
    this.closeSearch();
  }

  employStart(employmentStart) {
    //return this.datePipe.transform(employmentStart, 'dd/MM/yyyy');
    return employmentStart.replaceAll('-', '/');
  }

  endDatePersona(endDate, employed) {
    if (endDate != '' && !employed) {
      return ' - ' + endDate.replaceAll('-', '/');
    } else {
      return '';
    }
  }

  getResPersone(resPersone:any){
    let res=[];
    if(resPersone != null && typeof resPersone != typeof undefined){
      if(resPersone.value != null && typeof resPersone.value != typeof undefined){
        res = resPersone.value;
      }
    }
    return res;
  }

}
